import {Component, Input, OnInit} from '@angular/core';
import {ExcRestService} from 'exc-rest-v2';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcFileItem} from 'exc-upload-v2';

@Component({
  selector: 'app-modal-dialogue-questions',
  templateUrl: './modal-dialogue-questions.component.html',
  styles: []
})
export class ModalDialogueQuestionsComponent extends ExcTranslation implements OnInit {

  @Input() data: {vorgID: string, questions: any} = {vorgID: '', questions:[]};

  df_answers = [] as any[];

  responseData = [] as any[];

  vorgID = '' as any;

  constructor(private excRestService: ExcRestService,
              public modalService: ExgModalService) {
    super();
  }


  ngOnInit(): void {
    this.vorgID = this.data?.vorgID;
    this.responseData = this.data?.questions;
  }

  save(): void {
    for (let i = 0; i < this.responseData.length; i++) {
      this.df_answers.push({dfID:this.responseData[i].dfID, deValue:this.responseData[i].deValue, deUPT:this.responseData[i].deUPT})
    }
    this.modalService.action({df_answers: this.df_answers})
  }

  close(): void {
    this.modalService.close();
  }

}
